import { create } from 'zustand';

interface FunnelState {
  previousPath: string | null;
  isGoingBack: boolean;
  accessDenied: {
    message: string;
    nextPath: string;
  };
  previousQuestionId: string | null;
  isShowProgressBar: boolean;
  setPreviousPath: (path: string) => void;
  clearPreviousPath: () => void;
  setGoingBack: (value: boolean) => void;
  setAccessDeniedMessage: (value: { message: string; nextPath: string }) => void;
  setPreviousQuestionId: (id: string) => void;
  setShowProgressBar: (value: boolean) => void;
}

export const useFunnelStore = create<FunnelState>((set) => ({
  previousPath: null,
  isGoingBack: false,
  accessDenied: {
    message: '',
    nextPath: '',
  },
  previousQuestionId: null,
  isShowProgressBar: false,
  setPreviousPath: (path) => set({ previousPath: path }),
  clearPreviousPath: () => set({ previousPath: null, isGoingBack: false }),

  setGoingBack: (value) => set({ isGoingBack: value }),
  setAccessDeniedMessage: (value) =>
    set({ accessDenied: { message: value.message, nextPath: value.nextPath } }),
  setPreviousQuestionId: (id: string) => set({ previousQuestionId: id }),
  setShowProgressBar: (value) => set({ isShowProgressBar: value }),
}));
